<template>
  <div v-if="card != null" id="show-logradius-card">
    <v-row>
      <v-col cols="12">
        <logradius-datatable
          :firstLoad="firstLoad"
          :is-loading="isLoading"
          :logsradius="logsradius"
        ></logradius-datatable>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { onMounted, toRefs } from "@vue/composition-api";
import router from "../router";
import { useLogRadius } from "@/composables/logradius";
import LogradiusDatatable from "@/components/Logradius/LogradiusDatatable";
import { useCard } from "@/composables/card";
import { useTitle } from "@/composables/title";
export default {
  components: { LogradiusDatatable },
  setup() {
    const { setTitle } = useTitle();
    const { cardData, showCard } = useCard();
    const { listLogradiusForCard, logsradius, logradiusData } = useLogRadius();
    const cardId = router.currentRoute.params.cardId;
    setTitle("Liste des Logs RADIUS pour la carte :" + cardId);

    onMounted(() => {
      showCard(cardId);
      listLogradiusForCard(cardId);
    });

    return {
      ...toRefs(cardData),
      logsradius,
      ...toRefs(logradiusData),
    };
  },
};
</script>
